// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)

// ** Axios Imports
import axios from 'axios'

export const getAll = createAsyncThunk('documents/getAll', async () => {
  const response = await axios.get('/documents')
  return response.data
})

export const addData = createAsyncThunk(
  'documents/addData',
  async (major, { dispatch }) => {
    const response = await axios.post('/documents', major)
    await dispatch(getAll())
    return response.data
  }
)

export const updateData = createAsyncThunk(
  'documents/updateData',
  async (major, { dispatch }) => {
    const response = await axios.put(`/documents/${major.id}`, major)
    await dispatch(getAll())
    return response.data
  }
)

export const deleteData = createAsyncThunk(
  'documents/deleteData',
  async ({ id }, { dispatch }) => {
    const response = await axios.delete(`/documents/${id}`)
    await dispatch(getAll())
    return response.data
  })


export const dataSlice = createSlice({
  name: 'documents',
  initialState: {
    results: [],
    result: null,
    selected: null,
    isLoading: false
  },
  reducers: {
    selectData: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAll.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.isLoading = false
        state.results = action.payload
      })
      .addCase(addData.rejected, () => {
        MySwal.fire({
          title: 'Failed!',
          text: 'Add Data failed',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(addData.fulfilled, () => {
        MySwal.fire({
          title: 'Success!',
          text: 'Add Data Succcessfully',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(updateData.rejected, () => {
        MySwal.fire({
          title: 'Failed!',
          text: 'Update Data failed',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(updateData.fulfilled, () => {
        MySwal.fire({
          title: 'Success!',
          text: 'Update Data Succcessfully',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(deleteData.rejected, () => {
        MySwal.fire({
          title: 'Failed!',
          text: 'Delete data failed',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(deleteData.fulfilled, () => {
        MySwal.fire({
          title: 'Success!',
          text: 'Delete data Succcessfully',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
  }
})
export const { selectData } = dataSlice.actions
export default dataSlice.reducer
